<div class="container cpal">
  <div class="row mb-5">
    <h2>Historial de Solicitudes</h2>
  </div>

  <mat-table [dataSource]="solicitudes" class="mb-5">
    <ng-container matColumnDef="monto">
      <mat-header-cell *matHeaderCellDef>Monto</mat-header-cell>
      <mat-cell *matCellDef="let solicitud">{{ solicitud.monto | currency:'CLP':'symbol':'1.0-0' }}</mat-cell>
    </ng-container>
  
    <ng-container matColumnDef="duracion">
      <mat-header-cell *matHeaderCellDef>Plazo (meses)</mat-header-cell>
      <mat-cell *matCellDef="let solicitud">{{ solicitud.duracion }} meses</mat-cell>
    </ng-container>
  
    
    
    <ng-container matColumnDef="fechaSolicitud">
      <mat-header-cell *matHeaderCellDef>Fecha Solicitud</mat-header-cell>
      <mat-cell *matCellDef="let solicitud">{{ (solicitud.fechaSolicitud | date:'dd-MM-yyyy') }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="fechaTermino">
      <mat-header-cell *matHeaderCellDef>Fecha Término</mat-header-cell>
      <mat-cell *matCellDef="let solicitud">
        {{ (agregarDias(solicitud.fechaSolicitud,5) | date:'dd-MM-yyyy') }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="estado">
      <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
      <mat-cell *matCellDef="let solicitud">
        <span [appButtonColor]="solicitud.estadoSolicitudCredito">{{ solicitud.estadoSolicitudCredito | capitalizeEnum }}</span>
      </mat-cell>
    </ng-container>
    
    
    <!-- <ng-container matColumnDef="acciones">
      <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
      <mat-cell *matCellDef="let solicitud">
        <mat-icon mat-icon-button (click)="verDetalle(solicitud)" matTooltip="Ver detalles">
          visibility</mat-icon>
      </mat-cell>
    </ng-container> -->
    

    <mat-header-row *matHeaderRowDef="['monto', 'duracion', 'fechaSolicitud','fechaTermino', 'estado']"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['monto', 'duracion', 'fechaSolicitud','fechaTermino', 'estado']"></mat-row>
  </mat-table>

</div>
